export const baseURL = "https://apiloyaltystaging.novusloyalty.com/web/api/"; // URL for Live